// extracted by mini-css-extract-plugin
export default {"giftPointBody":"OwnerPoint_giftPointBody__5uUzr","okBtn":"OwnerPoint_okBtn__pjg16"};